import { useEffect } from 'react';
import * as L from 'leaflet';
import { useMapStore } from '../MapStore/UseMapStore';
import {
  createStandardIcon,
  handleItemClick,
  handleStandardHover,
  handlePopupAndMenuOverlap,
  updateMarkerSizes,
} from '../MapFunctions/MapHelperFunctions';

export function useAssetsLayer() {
  const assetFC = useMapStore((s) => s.assetFC);
  const assetLayer = useMapStore((s) => s.assetLayer);
  const setAssetLayer = useMapStore((s) => s.setAssetLayer);
  const setAssetRefLayer = useMapStore((s) => s.setAssetRefLayer);

  const showInfo = useMapStore((s) => s.showInfo);
  const setSelected = useMapStore((s) => s.setSelected);
  const setClickEvent = useMapStore((s) => s.setClickEvent);
  const setShowInfo = useMapStore((s) => s.setShowInfo);
  const setShowMore = useMapStore((s) => s.setShowMore);
  const markerSize = useMapStore((s) => s.markerSize);

  useEffect(() => {
    if (!assetLayer) return;

    // Clear old layers
    assetLayer.clearLayers();
    setAssetRefLayer(null);

    if (!assetFC) return;

    // Create GeoJSON layer with click handling
    const curAssets = new L.GeoJSON(assetFC, {
      onEachFeature(feature, layer) {
        handleItemClick(
          feature,
          layer,
          'asset',
          showInfo,
          setSelected,
          handlePopupAndMenuOverlap,
          setClickEvent,
          setShowInfo,
          setShowMore,
        );
        handleStandardHover(feature);
      },
      pointToLayer: (feature, latlng) => createStandardIcon(feature, latlng, 'asset', markerSize),
    });

    // Add to cluster layer and build reference map
    const newRef: Record<string, L.Layer> = {};
    curAssets.eachLayer((layer) => {
      newRef[layer.feature.properties.Id] = layer;
      assetLayer.addLayer(layer);
    });

    setAssetLayer(assetLayer);
    setAssetRefLayer(newRef);
  }, [
    assetFC,
    assetLayer,
    showInfo,
    setAssetLayer,
    setAssetRefLayer,
    setSelected,
    setClickEvent,
    setShowInfo,
    setShowMore,
  ]);

  useEffect(() => {
    updateMarkerSizes(assetLayer, 'asset', markerSize);
  }, [markerSize, assetLayer]);
}
